import React from 'react'

class MapSidebar extends React.Component {
  static propTypes = {
    children: React.PropTypes.element
  }

  render () {
    return (
      <div className="redi-component-map-sidebar">
        {this.props.children}
      </div>
    )
  }
}

export default MapSidebar



// WEBPACK FOOTER //
// ./modules/shared/components/mapSidebar.js